export const navigation = [
  {
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'icon-speedometer',
  },
  {
    name: 'Calendar',
    url: '/calendar',
    icon: 'icon-calendar',
  },
  {
    name: 'Events',
    url: '/events',
    icon: 'icon-notebook',
  },
  {
    name: 'Dealers',
    url: '/dealers',
    icon: 'icon-user',
  },
  {
    name: 'Staff',
    url: '/staff',
    icon: 'icon-people ',
  },   
  {
    name: 'Event Packages',
    url: '/packages',
    icon: 'icon-notebook ',
  }, 


  /* {
    name: 'Emails',
    url: '/emails',
    icon: 'icon-speech',
  }, */

  {
    name: 'Global Properties',
		url: '/',
    icon: 'icon-settings',
	  children: [
  	  {
    		name: 'OEM',
    		url: '/oem',
    		icon: 'icon-list',
  	  },
  	  {
    		name: 'Brands',
    		url: '/brand',
    		icon: 'icon-list',
  	  },
  	  {
    		name: 'Centers',
    		url: '/center',
    		icon: 'icon-list',
  	  },
  	  {
        name: 'MR',
        url: '/mr',
        icon: 'icon-list',
      },
      {
    		name: 'Auto Groups',
    		url: '/auto-group',
    		icon: 'icon-list',
  	  },  	  
  	  {
    		name: 'Advertising Agency',
    		url: '/advertisingagency',
    		icon: 'icon-list',
  	  },  	  
  	  {
    		name: 'Dealers Contact Role',
    		url: '/contactrole',
    		icon: 'icon-list',
  	  }
	  ]
	},

	{
		name: 'Event Status',
		url: '/project-status',
		icon: 'icon-doc ',
	},
	{
		name: 'Contract Content',
		url: '/contract-content',
		icon: 'icon-doc ',
	},
	{
		name: 'Email Content',
		url: '/email-content',
		icon: 'icon-doc ',
	}
  
];

export const staffnavigation = [
  {
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'icon-speedometer',
  },
  {
    name: 'Calendar',
    url: '/calendar',
    icon: 'icon-calendar',
  },
  {
    name: 'Events',
    url: '/events',
    icon: 'icon-notebook',
  },
   /* {
    name: 'Profile',
    url: '/profile/staff',
    icon: 'icon-user',
  }, */
  {
    name: 'Dealers',
    url: '/dealers',
    icon: 'icon-user',
  },
  {
    name: 'Invoices',
    url: '/invoices',
    icon: 'icon-list',
  }  
  
];

export const dealernavigation = [
  {
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'icon-speedometer',
  },
  {
    name: 'Calendar',
    url: '/calendar',
    icon: 'icon-calendar',
  },
  {
    name: 'Events',
    url: '/events',
    icon: 'icon-notebook',
  },
  /* {
    name: 'Profile',
    url: '/profile/dealer',
    icon: 'icon-user',
  }, */
  {
    name: 'Address',
    url: '/address',
    icon: 'icon-notebook',
  },
  {
    name: 'Data Upload',
    url: '/dataupload',
    icon: 'icon-list',
  }
  
];

export const suppliernavigation = [
  {
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'icon-speedometer',
  },
  {
    name: 'Calendar',
    url: '/calendar',
    icon: 'icon-calendar',
  },
  {
    name: 'Events',
    url: '/events',
    icon: 'icon-notebook',
  },
 /*  {
    name: 'Profile',
    url: '/profile/staff',
    icon: 'icon-user',
  } */
  
];


// WEBPACK FOOTER //
// /var/www/portaldev/bullseye/src/app/_nav.ts